import React, { useEffect, useContext, useState } from 'react';
import { useHistory } from "react-router-dom";
import { Typography } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Alert from '@material-ui/lab/Alert';
import SunEditor from 'suneditor-react';
import Chip from '@material-ui/core/Chip';

import { getClaimableChallengeReward, claimChallengeReward } from '../../../actions/challenge-actions';
import StudentContext from '../../../context/student-context';
import ChallengeContext from '../../../context/challenge-context'

import { BreadcrumbsCustom } from '../../shared/component'
import useStyles from '../../../styles/components/learningcontent/stylesLearningContents'
import { Claims } from '../../../utils/services/cache/ClientCache'
import RewardLogDialog from './RewardLogDialog'
import { Coin } from '../../shared/component'

const ChallengeOverview = () => {

    const classes = useStyles();
    const history = useHistory();
    const { dispatchStudent, studentContext } = useContext(StudentContext);
    const { challengeContext, dispatch } = useContext(ChallengeContext);
    const [claimableReward, setClaimableReward] = useState({ rewardLogId: 0, ableToClaim: false, isClaimed: false, rewardCoin: 0, rank: 0 });
    const [isLoading, setIsLoading] = useState(true);
    const [rewardLogModel, setRewardLogModel] = useState({ open: false, message: '', severity: 'info', isLoading: false })

    useEffect(() => {
        initClaimableReward();
    }, []);

    const initClaimableReward = async () => {
        if (challengeContext.challenge.IsEnded && challengeContext.challenge.IsSignedUp) {

            let challengeId = challengeContext.challenge.ChallengeId;
            let teamId = challengeContext.challenge.TeamMemberViewModels[0].TeamId;
            let studentNumber = Claims.getGivenName();
            const response = await getClaimableChallengeReward(challengeId, teamId, studentNumber);
            setIsLoading(false);
            if (response > 200 || response.status === "Failed") {
                dispatch({ type: 'SET_LOADING', loading: false });
                return history.push("/SessionTimeOut")
            }

            if (response.status === "Success") {
                let rewardLog = response.data;
                if (rewardLog.Id > 0) {
                    setClaimableReward(
                        {
                            rewardLogId: rewardLog.Id,
                            ableToClaim: true,
                            isClaimed: rewardLog.IsClaimed,
                            rewardCoin: rewardLog.RewardCoin,
                            rank: rewardLog.Rank
                        })
                }
            }
        }
    };

    const breadcrumbsData = [
        {
            text: 'Challenge',
            href: '/Challenge'
        },
        {
            text: 'Challenge Overview',
            href: ''
        },
    ];

    const signUpDialogOpen = () => {
        challengeContext.signUpForm.challengeId = challengeContext.challenge.ChallengeId;
        challengeContext.signUpForm.teamMembers[0].studentNumber = Claims.getGivenName();
        challengeContext.signUpForm.teamMembers[0].isLeader = true;
        dispatch({ type: 'SET_SIGNUPFORM', signUpForm: challengeContext.signUpForm });

        challengeContext.dialogs.signUpDialog = true;
        dispatch({ type: 'SET_DIALOGS', dialogs: challengeContext.dialogs });
    }

    const handleClickTabs = (item) => {

        switch (item) {
            case "overview":
                challengeContext.tabs.overview = true;
                challengeContext.tabs.teamMember = false;
                challengeContext.tabs.activities = false;
                challengeContext.tabs.leaderboard = false;
                dispatch({ type: 'SET_TABS', tabs: challengeContext.tabs });
                break;
            case "teamMember":
                challengeContext.tabs.overview = false;
                challengeContext.tabs.teamMember = true;
                challengeContext.tabs.activities = false;
                challengeContext.tabs.leaderboard = false;
                dispatch({ type: 'SET_TABS', tabs: challengeContext.tabs });
                break;
            case "activities":
                challengeContext.tabs.overview = false;
                challengeContext.tabs.teamMember = false;
                challengeContext.tabs.activities = true;
                challengeContext.tabs.leaderboard = false;
                dispatch({ type: 'SET_TABS', tabs: challengeContext.tabs });
                break;
            case "leaderboard":
                challengeContext.tabs.overview = false;
                challengeContext.tabs.teamMember = false;
                challengeContext.tabs.activities = false;
                challengeContext.tabs.leaderboard = true;
                dispatch({ type: 'SET_TABS', tabs: challengeContext.tabs });
                break;
        }
    }

    const handleUpdate = async (rewardLogId) => {
        setRewardLogModel({ open: true, message: 'Please wait for a while...', severity: 'info', isLoading: true })
        let rewardModel = { ChallengeRewardLogId: rewardLogId, StudentNumber: Claims.getGivenName() };
        let response = await claimChallengeReward(JSON.stringify(rewardModel));
        if (response > 200 || response.status === "Failed") {
            setRewardLogModel({ open: true, message: 'Your coins are not successfully redeemed.', severity: 'error', isLoading: false })
        }
        if (response.status === "Success") {
            let studentCoins = studentContext.studentCoins + claimableReward.rewardCoin;
            dispatchStudent({ type: 'SET_STUDENT_COINS', studentCoins: studentCoins });

            claimableReward.isClaimed = true;
            setClaimableReward(claimableReward);
            setRewardLogModel({ open: true, message: 'Your coins are successfully redeemed.', severity: 'success', isLoading: false })
        }
    };

    const handleOk = () => {
        setRewardLogModel({ open: false, message: '', severity: 'info', isLoading: false })
    };

    return (
        <>
            <BreadcrumbsCustom breadcrumbsData={breadcrumbsData} />
            <br />
            <Card>
                <CardMedia
                    component="img"
                    height="240"
                    alt="Challenge Background"
                    image="/assets/images/components/challenge/challengeOverview.jpg"
                    title="Challenge Background"
                />
                <CardContent>
                    <Typography gutterBottom variant="h5" component="h2">
                        {challengeContext.challenge.ChallengeTitle}
                    </Typography>
                    {
                        challengeContext.challenge.IsEnded ?
                            claimableReward.ableToClaim ?
                                <Alert icon={false} variant="filled" severity="success" style={{ backgroundColor: '#4DD091', fontSize: '16px' }}>
                                    {
                                        !claimableReward.isClaimed ?
                                            <div>Your Team ({challengeContext.challenge.TeamName}) completed this challenge with a rank #{claimableReward.rank}.
                                                Click <a className="standard-btn" onClick={() => handleUpdate(claimableReward.rewardLogId)}>Here</a> to claim your coins.</div>
                                            :
                                            <>
                                                Your Team ({challengeContext.challenge.TeamName}) completed this challenge with a rank #{claimableReward.rank}.
                                                You have already redeemed ({claimableReward.rewardCoin} coins).
                                            </>
                                    }
                                </Alert>
                                :
                                <Alert icon={false} variant="filled" severity="error" style={{ backgroundColor: '#ff5768', fontSize: '16px' }}>
                                    This challenge ended on {challengeContext.challenge.EndDate}.
                                </Alert>
                            :
                            <Typography variant="body1" component='div'>
                                #This challenge lasts from
                                {`  `}<Chip variant="outlined"
                                    label={challengeContext.challenge.StartDate}
                                /> {`  `}
                                to
                                {`  `}<Chip variant="outlined"
                                    label={challengeContext.challenge.EndDate}
                                /> {`  `}
                                .<br />
                                #This challenge is a <b>team-based</b> challenge.<br />
                                #This challenge requires a <b>minimum of 3 and a maximum of 5</b> participants per team.<br />
                                #The total price pool for this challenge is
                                {`  `}<Coin
                                    coin={challengeContext.challenge.RewardCoins}
                                    size="medium" />{`  `}
                                coins.<br />
                            </Typography>
                    }
                    <br />
                    <SunEditor
                        showToolbar={false}
                        enableToolbar={true}
                        disable={true}
                        setOptions={{
                            height: "100%",
                            resizingBar: false,
                        }}
                        toggleFullScreen={true}
                        setContents={challengeContext.challenge.ChallengeDescription}
                        showController={false}
                    />
                    <br />
                    {
                        challengeContext.challenge.IsSignedUp ?
                            challengeContext.challenge.IsEnded ?
                                <>
                                    <Alert icon={false} variant="outlined" severity="info" style={{ fontSize: '16px' }}>
                                        You had participated in this challenge. Click <a className="button one" onClick={() => handleClickTabs("teamMember")}>Here</a> to check team members' status.
                                    </Alert>
                                    <br />
                                    <Alert icon={false} variant="outlined" severity="info" style={{ fontSize: '16px' }}>
                                        Wondering which team is the winner? Click <a className="button one" onClick={() => handleClickTabs("leaderboard")}>Here</a> to see the leaderboard.
                                    </Alert>
                                </>
                                :
                                <>
                                    <Alert icon={false} variant="outlined" severity="info" style={{ fontSize: '16px' }}>
                                        You already have a team for this challenge. Click <a className="button one" onClick={() => handleClickTabs("teamMember")}>Here</a> to check team members' status.
                                    </Alert>
                                    <br />
                                    <Alert icon={false} variant="outlined" severity="info" style={{ fontSize: '16px' }}>
                                        In order to complete this challenge, you need to complete all activities. Click <a className="button one" onClick={() => handleClickTabs("activities")}>Here</a> to browse all activities.
                                    </Alert>
                                    <br />
                                    <Alert icon={false} variant="outlined" severity="info" style={{ fontSize: '16px' }}>
                                        Wondering which team is in the lead? Click <a className="button one" onClick={() => handleClickTabs("leaderboard")}>Here</a> to see the leaderboard.
                                    </Alert>
                                </>
                            :
                            challengeContext.challenge.IsEnded ?
                                <Alert icon={false} variant="outlined" severity="info" style={{ fontSize: '16px' }}>
                                    You did not participate in this challenge.
                                </Alert>
                                :
                                <Alert icon={false} variant="outlined" severity="info" style={{ fontSize: '16px' }}>
                                    You do not have a team for this challenge. Click <a className="button one" onClick={() => signUpDialogOpen()}>Here</a> to participate in this challenge.
                                </Alert>
                    }
                </CardContent>
            </Card>
            {
                rewardLogModel.open ?
                    <RewardLogDialog _handleClose={handleOk} _message={rewardLogModel.message} _severity={rewardLogModel.severity} _isLoading={rewardLogModel.isLoading} />
                    : <></>
            }
        </>
    );
};

export default ChallengeOverview;